import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '首页',
        about: false
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/news/index'),
      meta: {
        title: '新闻',
        about: false
      }
    },
    {
      path: '/news-info',
      name: 'news-info',
      component: () => import('@/views/news-info/index'),
      meta: {
        title: '新闻详细',
        about: false
      }
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: () => import('@/views/cooperation/index'),
      meta: {
        title: '合作伙伴',
        about: true
      }
    },
    {
      path: '/charitable',
      name: 'charitable',
      component: () => import('@/views/charitable/index'),
      meta: {
        title: '盛目慈善',
        about: false
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('@/views/recruit/index'),
      meta: {
        title: '人才招聘',
        about: false
      }
    },
    {
      path: '/desc',
      name: 'desc',
      component: () => import('@/views/desc/index'),
      meta: {
        title: '公司简介',
        about: true
      }
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('@/views/project/index'),
      meta: {
        title: '投资项目',
        about: true
      }
    },
    {
      path: '/project-info',
      name: 'project-info',
      component: () => import('@/views/project-info/index'),
      meta: {
        title: '',
        about: false
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/contact/index'),
      meta: {
        title: '联系我们',
        about: true
      }
    }
  ]
})
router.beforeEach((to, from, next) => {
  next()
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
})
router.afterEach((to, from) => {
  document.title = to.meta.title
})
export default router
